const DRAG_THRESHOLD_PX = 5;

/**
 * Tell a click from a drag on a handle.
 * `onDrag` returns true once a connection drag has started (listeners drop).
 * Return false to ignore movement — milestones and notes only open the menu.
 * With no `onDrag`, movement past the threshold cancels the click.
 */
export function armClickOrDrag(startEvent, { onDrag, onClick }) {
  const start = { x: startEvent.clientX, y: startEvent.clientY };
  let dragged = false;

  const handleMouseMove = (moveEvent) => {
    if (dragged) return;
    const dx = Math.abs(moveEvent.clientX - start.x);
    const dy = Math.abs(moveEvent.clientY - start.y);
    if (dx <= DRAG_THRESHOLD_PX && dy <= DRAG_THRESHOLD_PX) return;

    if (!onDrag) {
      dragged = true;
      return;
    }
    if (onDrag(moveEvent, start)) {
      dragged = true;
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }
  };

  const handleMouseUp = (upEvent) => {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
    if (!dragged) onClick?.(upEvent, start);
  };

  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
}
